import React, { useEffect } from "react";
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Link from "src/components/link";
const useStyles = makeStyles((theme) => ({
 
  page: {
    minHeight: '100vh',
   paddingTop: '100px'
  },
  container: {
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '1000px'
  }

}));
const DesignerTools = () => {
  const classes = useStyles();
  useEffect(() => {
    if(typeof(document) != 'undefined'){
      document.title = 'Designer Tools';
    }
  }, []);
  return (
    <div className={classes.page}>
      <div className={classes.container}>
      <h2>Các công cụ:</h2>
      <Link to="/designer-tools/change-thumbnail">
        <Button variant="contained">Đổi avatar và hình bài viết</Button>
      </Link>
      </div>

    </div>
  );
};

export default DesignerTools;
